import React from 'react'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'
import { IInvoiceWithCustomer } from './statistics'

interface OrderTrendChartProps {
  invoices: IInvoiceWithCustomer[]
}

export default function OrderTrendChart({ invoices }: OrderTrendChartProps) {
  // Aggregate by date for chart: { date: 'YYYY-MM-DD', orderCount: number }
  const data = React.useMemo(() => {
    const dateMap: { [date: string]: number } = {}
    invoices.forEach((invoice) => {
      const date = invoice.createdAt ? invoice.createdAt.slice(0, 10) : null
      if (date) {
        dateMap[date] = (dateMap[date] || 0) + 1
      }
    })
    return Object.entries(dateMap)
      .map(([date, orderCount]) => ({ date, orderCount }))
      .sort((a, b) => a.date.localeCompare(b.date))
  }, [invoices])

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart
        data={data}
        margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis allowDecimals={false} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="orderCount"
          stroke="#8884d8"
          strokeWidth={2}
        />
      </LineChart>
    </ResponsiveContainer>
  )
}
